module.exports = Date.now || now

function now() {
    return new Date().getTime()
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/debounce/~/date-now/index.js
 ** module id = 479
 ** module chunks = 0
 **/